import { Amplify } from 'aws-amplify';

//console.log('Process00');
//console.dir(process);

const config = {
  TITLE: process.env.REACT_APP_TITLE ? process.env.REACT_APP_TITLE : "No title",

  s3: {
    REGION: process.env.REACT_APP_S3_REGION?process.env.REACT_APP_S3_REGION : "",
    BUCKET: process.env.REACT_APP_S3_BUCKET?process.env.REACT_APP_S3_BUCKET : "",
  },
  apiGateway: {
    REGION: process.env.REACT_APP_APIGATEWAY_REGION?process.env.REACT_APP_APIGATEWAY_REGION:"",
    URL: process.env.REACT_APP_APIGATEWAY_URL?process.env.REACT_APP_APIGATEWAY_URL:"",
  },
  cognito: {
    REGION: process.env.REACT_APP_COGNITO_REGION?process.env.REACT_APP_COGNITO_REGION:"",
    USER_POOL_ID: process.env.REACT_APP_COGNITO_USER_POOL_ID?process.env.REACT_APP_COGNITO_USER_POOL_ID:"",
    APP_CLIENT_ID: process.env.REACT_APP_COGNITO_APP_CLIENT_ID?process.env.REACT_APP_COGNITO_APP_CLIENT_ID:"",
    IDENTITY_POOL_ID: process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID?process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID:"",
    SUB1_SUB: process.env.REACT_APP_COGNITO_SUB1_SUB?process.env.REACT_APP_COGNITO_SUB1_SUB:"",
    SUB2_SUB: process.env.REACT_APP_COGNITO_SUB2_SUB?process.env.REACT_APP_COGNITO_SUB2_SUB:"",
    SHARED_SUB: process.env.REACT_APP_COGNITO_SHARED_SUB?process.env.REACT_APP_COGNITO_SHARED_SUB:"",
    SHARED_ID: process.env.REACT_APP_COGNITO_SHARED_ID?process.env.REACT_APP_COGNITO_SHARED_ID:"",
  },
  public: {
    LOGO: process.env.REACT_APP_LOGO?process.env.REACT_APP_LOGO:"",
    SUPPORT_PHONE: process.env.REACT_APP_SUPPORTPHONE ? process.env.REACT_APP_SUPPORTPHONE : "",
    SUPPORT_EMAIL: process.env.REACT_APP_SUPPORTEMAIL ? process.env.REACT_APP_SUPPORTEMAIL : "",
    CONTACT: process.env.REACT_APP_CONTACT ? process.env.REACT_APP_CONTACT : ""
    },
  googleAnalytics: {
    CODE: process.env.REACT_APP_GACODE?process.env.REACT_APP_GACODE:""
  },
  recaptcha: {
    SITEKEY: process.env.REACT_APP_RECAPTCHA_SITEKEY?process.env.REACT_APP_RECAPTCHA_SITEKEY:null
  }
};

Amplify.configure({
  Auth: {
    mandatorySignIn: true,
    region: config.cognito.REGION,
    userPoolId: config.cognito.USER_POOL_ID,
    identityPoolId: config.cognito.IDENTITY_POOL_ID,
    userPoolWebClientId: config.cognito.APP_CLIENT_ID
  },
  Storage: {
    region: config.s3.REGION,
    bucket: config.s3.BUCKET,
    identityPoolId: config.cognito.IDENTITY_POOL_ID,
    customPrefix: {
      public: 'resources/public/',
      protected: 'resources/protected/',
      private: 'resources/private/',
    }
  },
  API: {
    endpoints: [
      {
        name: "notes",
        endpoint: config.apiGateway.URL,
        region: config.apiGateway.REGION
      },
    ]
  }
});
  
export default config;